import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { AbstractEffects } from '../AbstractEffects';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { util } from '../../util/util';

import * as invoiceActions from '../sap-invoice/sap-invoice.actions';
import { BlobAction } from '../sap-invoice/sap-invoice.actions';
import * as flowDetailActions from '../edit-flow-detail/flow-detail.actions';
import * as flowsActions from '../flows/flows.actions';
import * as orderDetailActions from '../order-detail/order-detail.actions';
import * as ordersActions from '../orders/orders.actions';
import * as blankReceiptsActions from '../blank-receipts/blank-receipts.actions';
import * as usersActions from '../admin/users/users.actions';
import * as stockCountActions from '../stock-count/stock-count.actions';
import { tap } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class OpenPdfEffect extends AbstractEffects {
  openPdf$: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType<BlobAction>(
          invoiceActions.SAP_INVOICE_DOWNLOAD_SUCCESS,
          invoiceActions.SAP_INVOICE_DOWNLOAD_LIST_SUCCESS,
          flowDetailActions.FLOWDETAIL_DOCUMENT_DOWNLOAD_SUCCESS,
          flowsActions.FLOWS_DOWNLOAD_SUCCESS,
          orderDetailActions.ORDERDETAIL_DOCUMENT_DOWNLOAD_SUCCESS,
          orderDetailActions.ORDERDETAIL_CCR_DOCUMENT_DOWNLOAD_SUCCESS,
          ordersActions.ORDERS_DOWNLOAD_SUCCESS,
          blankReceiptsActions.BLANK_RECEIPT_CREATE_SUCCESS,
          usersActions.CLIENT_USER_BULK_DOWNLOAD_EXAMPLE_SUCCESS,
          stockCountActions.STOCK_COUNTS_PRINT_LOAD_SUCCESS
        ),
        tap((action: BlobAction) => {
          util.openBlob(action.payload.blob, action.payload.filename.toLocaleLowerCase());
        })
      ),
    { dispatch: false }
  );

  constructor(azureMonitoringService: AzureMonitoringService, private actions$: Actions, translateService: TranslateService, notificationService: NotificationService) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
